module.exports = __webpack_public_path__ + "static/media/ps_logo_animated.36dd48a7.gif";